package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class BulkEpisodeImportResponse(
    val importType: String,
    val status: String,
    val totalFiles: Int,
    val successfulFiles: Int,
    val failedFiles: Int,
    val audiobookCount: Int,
    val results: List<AudiobookImportResult>,
    val createdAt: String
)

@Serializable
data class AudiobookImportResult(
    val isbn: String? = null,
    val title: String? = null,
    val status: String,
    val successCount: Int = 0,
    val failureCount: Int = 0,
    val skippedCount: Int = 0,
    val errors: List<String> = emptyList(),
    val error: String? = null,
    val fileCount: Int = 0,
    val files: List<String> = emptyList()
)
